import { useState } from "react";

interface Props {
  orientation: "portrait" | "landscape";
  src: string;
}

const Iframe = ({ orientation, src }: Props) => {
  const [isLoading, setIsLoading] = useState(true);

  // Handle iframe load
  const handleIframeLoad = () => {
    setIsLoading(false);
  };

  return (
    <div
      className={`${orientation === `landscape` ? `aspect-[1.53846] w-full max-w-[1000px]` : `h-[500px] w-full xxs:w-[236px] sm:h-[600px] sm:w-[320px]`} mb-8 rounded-xl border-2 bg-white px-0 py-1 shadow-xl sm:p-1`}
    >
      <div className="h-full w-full overflow-hidden rounded-xl border">
        {isLoading && (
          <div
            className={`flex ${orientation === "landscape" ? `aspect-[1.53846]` : `h-full`} w-full animate-pulse items-center justify-center bg-gray-300`}
          >
            {/* <Spinner /> */}
          </div>
        )}
        <iframe
          title={`Template Preview}`}
          src={src}
          className={`${orientation === `landscape` ? `h-[calc(100%*2)] w-[calc(100%*1.92)] max-w-[1920px] origin-top-left scale-[0.52]` : `h-[833.33px] w-[385px] origin-top-left scale-[0.6] sm:h-[750px] sm:scale-[0.8]`} ${isLoading ? `hidden` : `block`}`}
          onLoad={handleIframeLoad}
        ></iframe>
      </div>
    </div>
  );
};

export default Iframe;
